export default "__VITE_ASSET__1aa9b447__"